<template>

    <Page>
        <div class="grid grid-cols-2 gap-20 2xl:gap-64">
            <Image src="/PointOfSale/rewards-pullup-banner.png" class="scale-[125%]" floor-shadow />
            <Image src="/PointOfSale/protect-pullup-banner.png" class="scale-[125%]" floor-shadow />
        </div>
    </Page>

</template>